import styled from 'styled-components';
import {
  borderRadius,
  breakpoints,
  colors,
  text,
  verticalGutter
} from '../../../styles';

export default styled.div`
  height: calc(100% - ${verticalGutter}rem / 4);

  i.icon.close {
    position: absolute;
    right: 0;
    opacity: 1;
    z-index: 1;
  }

  .ui.card {
    height: 100%;
    font-size: ${text.mini};
    figure {
      margin: 0;
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: ${(9 / 16) * 100}%;
      overflow: hidden;
      > * {
        position: absolute;
        width: 100%;
        height: auto;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .extra {
      border-top: none !important;
      padding-top: 0;
    }
  }

  /* namespaced styles */
  .images-field {
    &__drop {
      height: calc(100% - ${verticalGutter}rem / 4);
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      background: #fff;
      min-height: 10rem;
      padding: ${verticalGutter * 2}rem;
      border-radius: ${borderRadius.small};
      color: ${colors.grey};

      &,
      &__placeholder {
        > * {
          position: relative;
          z-index: 1;
        }
      }

      /* inside of preview */
      &__placeholder {
        display: flex !important;
        justify-content: center;
        align-items: center;
        min-height: 10rem;
        i.icon.plus {
          border-color: ${colors.lighterGrey};
          margin: 0;
          &:before,
          &:after {
            background: ${colors.lighterGrey} !important;
          }
        }
      }

      &:before,
      &__placeholder:before {
        content: '';
        display: block;
        position: absolute;
        left: ${verticalGutter / 2}rem;
        right: ${verticalGutter / 2}rem;
        top: ${verticalGutter / 2}rem;
        bottom: ${verticalGutter / 2}rem;
        border: 2px dashed ${colors.lighterGrey};
        border-radius: ${borderRadius.large};
        transition: border 0.3s ease;
      }

      &:focus,
      &--dragging {
        outline: none;
        &:before,
        .images-field__drop__placeholder:before {
          border-color: ${colors.primary};
          background: ${colors.greenBackground};
        }
        .images-field__drop__placeholder {
          i.icon.plus {
            border-color: ${colors.primary};
            &:before,
            &:after {
              background: ${colors.primary} !important;
            }
          }
        }
      }

      &--dropped {
        padding: ${verticalGutter}rem;
        &:before {
          display: none;
        }
      }
    }

    &__preview {
      position: relative;
      width: calc(100% + ${verticalGutter}rem);

      > .column:not(.row) {
        width: 100%;
        @media screen and (min-width: ${breakpoints.tablet}) {
          width: ${(1 / 2) * 100}%;
        }
        @media screen and (min-width: ${breakpoints.computer}) {
          width: 100%;
        }
        @media screen and (min-width: ${breakpoints.largeMonitor}) {
          width: ${(1 / 3) * 100}%;
        }
      }
    }

    &__dummy {
      background: ${colors.borderGrey};
      text-transform: uppercase;
      color: #fff;
    }
  }
`;
